import { SITE_VOICE } from '../siteVoice';

/** Keyed by `KeyboardEvent.code` (with some `event.key` fallbacks handled in demo). */
export const keyboardSpecialLookup: Record<
  string,
  { bytes: string; sequence: string; desc: string }
> = {
  ArrowUp: { bytes: '1b 5b 41', sequence: '^[[A', desc: 'Cursor Up' },
  ArrowDown: { bytes: '1b 5b 42', sequence: '^[[B', desc: 'Cursor Down' },
  ArrowRight: { bytes: '1b 5b 43', sequence: '^[[C', desc: 'Cursor Right' },
  ArrowLeft: { bytes: '1b 5b 44', sequence: '^[[D', desc: 'Cursor Left' },
  Enter: { bytes: '0d', sequence: '^M', desc: 'Carriage Return' },
  Tab: { bytes: '09', sequence: '^I', desc: 'Horizontal Tab' },
  Backspace: { bytes: '7f', sequence: '^?', desc: 'Delete' },
  Escape: { bytes: '1b', sequence: '^[', desc: 'Escape' },
};

export const keyboardDemo = {
  labels: {
    bytes: 'Bytes',
    sequence: 'Sequence',
  },
  emptyState: {
    title: 'Press any key',
    subtitle: SITE_VOICE.keyboardEmptySubtitle,
  },
  characterDescPrefix: 'Character ',
  footerIntro:
    'When I press an arrow key, the terminal doesn\'t ship the string "arrow up" — it emits ',
  footerAfterArrowBytes: '(three bytes). Programs that don\'t understand this will print ',
  footerLiteralOutro: ' literally.',
  codes: {
    escPhrase: 'ESC [ A',
    caretSequence: '^[[A',
  },
} as const;
